export default __webpack_public_path__ + "static/media/Baskerville-Italic.8f07e7e6.woff";